<div class="dialog-title-row" fxLayout="row" fxLayoutAlign="space-between center">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <button mat-icon-button class="close-button" (click)="close()" aria-label="Fechar">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="dialog-content">
  <mat-card class="p-0 popup-wrapper">
    <div class="popup-actions">
      <button mat-raised-button color="primary" (click)="$event.preventDefault(); popUpVendedor({}, true)">
        <mat-icon>person_add</mat-icon>
        {{"ADD" | translate }} {{"VENDEDOR" | translate }}
      </button>
    </div>

    <ng-container *ngIf="layoutConf?.isMobile; else desktopVendedorTable">
      <div class="mobile-cards-wrap" *ngIf="cadastroVendedores?.length; else emptyVendedorList">
        <mat-card class="mobile-card" *ngFor="let row of cadastroVendedores; let i = index">
          <div class="mobile-card-header">
            <div class="mobile-card-title">
              #{{ i + 1 }} - {{ (row?.vendedor?.codigo ?? 0).toString().padStart(6, '0') + ' - ' + (row?.vendedor?.razaoSocial || '') }}
            </div>
            <div class="mobile-card-actions">
              <button mat-icon-button color="primary" matTooltip="Editar" (click)="$event.preventDefault(); popUpVendedor(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" matTooltip="Excluir" (click)="$event.preventDefault(); deleteVendedor(row)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

          <div class="mobile-card-grid">
            <div><span>Código</span><strong>{{ (row?.vendedor?.codigo ?? 0).toString().padStart(6, '0') }}</strong></div>
            <div><span>Cidade</span><strong>{{ row?.vendedor?.cadMun?.municipio || '-' }}{{ row?.vendedor?.cadMun?.uf ? '/' + row?.vendedor?.cadMun?.uf : '' }}</strong></div>
          </div>

          <div class="mobile-card-line" *ngIf="row?.vendedor?.email">
            <span>E-mail</span>
            <strong>{{ row?.vendedor?.email }}</strong>
          </div>
        </mat-card>
      </div>

      <mat-paginator
        class="mobile-paginator"
        #paginatorVendedor
        [length]="lengthVendedor"
        [showFirstLastButtons]="true"
        [pageSize]="pageSizeVendedor"
        [pageSizeOptions]="pageSizeOptionsVendedor"
        (page)="pageEventVendedor = setPageSizeOptionsVendedor($event)">
      </mat-paginator>
    </ng-container>

    <ng-template #desktopVendedorTable>
      <ngx-datatable class="material ml-0 mr-0" [rows]="cadastroVendedores" [headerHeight]="50" [footerHeight]="50"
        [scrollbarH]="true" [messages]="{emptyMessage:'Nenhum Vendedor encontrado'}" [limit]="pageSizeVendedor"
        [rowHeight]="50">
        <ngx-datatable-column name="#" [width]="25">
          <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <strong>{{ rowIndex + 1 }}</strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Opções" [flexGrow]="1" [width]="100">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <button mat-icon-button mat-sm-button color="primary" class="mr-1" (click)="$event.preventDefault(); popUpVendedor(row)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button mat-sm-button color="warn" (click)="$event.preventDefault(); deleteVendedor(row)">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Vendedor/Representante" [flexGrow]="1" [width]="425">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ (row?.vendedor?.codigo ?? 0).toString().padStart(6, '0') + '-' + (row?.vendedor?.razaoSocial || '') }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="E-mail" [flexGrow]="1" [width]="250">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.vendedor?.email }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Cidade" [flexGrow]="1" [width]="250">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.vendedor?.cadMun?.municipio?.trim() + '/' + row?.vendedor?.cadMun?.uf }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
          <ng-template ngx-datatable-footer-template>
            <mat-paginator
              #paginatorVendedor
              [length]="lengthVendedor"
              fxLayoutAlign="space-around center"
              [showFirstLastButtons]="true"
              [pageSize]="pageSizeVendedor"
              [pageSizeOptions]="pageSizeOptionsVendedor"
              (page)="pageEventVendedor = setPageSizeOptionsVendedor($event)">
            </mat-paginator>
          </ng-template>
        </ngx-datatable-footer>
      </ngx-datatable>
    </ng-template>

    <ng-template #emptyVendedorList>
      <div class="empty-state">Nenhum vendedor/representante encontrado.</div>
    </ng-template>
  </mat-card>
</div>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button color="warn" type="button" (click)="close()">
    <mat-icon>close</mat-icon>
    {{"CLOSE" | translate }}
  </button>
</mat-dialog-actions>